export const dataEmptyChecker = (data: string | undefined): boolean =>
  !data || data?.trim() === '';
